import React, { useState, useEffect } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Card, Collapse } from "react-bootstrap";
import findFilterValue from "helpers/find-filter-value";
import searchOperationGenerator from "helpers/search-operation-generator";
import FilterItem from "views/lib/components/filter/filter-item";
import FilterHeader from "views/lib/components/filter/filter-header";
import { getWalletFilters } from "actions/wallet/actions";
import { getCurrencies } from "actions/transaction/actions";
import filterTypes from "data/filter-types";

const WalletFilers = (props) => {
  const { currencies, activeFilters, totalCount, walletFilters, handleReset, getCurrencies, getWalletFilters, handleSearch } = props;
  const [isOpen, setIsOpen] = useState(false);
  const [filters, setFilters] = useState(activeFilters);

  const handleSearchLocal = () => {
    const filtersToArray = Object
      .keys(filters)
      .filter(name => Object.keys(filters[name]).length)
      .map(name => filters[name]);
    handleSearch(filtersToArray);
  };

  const handleChangeFilter = (name, valueObject) => {
    setFilters({
      ...filters,
      [name]: valueObject
    });
  };

  const handleResetLocal = () => {
    setFilters({});
    handleReset();
  };

  useEffect(() => {
    getCurrencies();
    getWalletFilters();
  }, [getCurrencies, getWalletFilters]);

  const resultFilers = {
    ...filters
  };

  return (
    <Card className="w-100 mb-2 rounded-0">
      <FilterHeader
        title="Wallet"
        totalCount={totalCount}
        isOpen={isOpen}
        onToggle={setIsOpen}
      />
      <Card.Body className="p-0">
        <Collapse in={isOpen} className="p-3" timeout={0}>
          <div className="row">
            <div className="col-12 col-md-3 mb-3">
              <FilterItem
                name="id"
                placeholder="ID"
                filterType="text"
                defaultValue=""
                onChange={handleChangeFilter}
                searchOperation={searchOperationGenerator(walletFilters.walletId)}
                value={findFilterValue("id", resultFilers)}
              />
            </div>
            <div className="col-12 col-md-3 mb-3">
              <FilterItem
                name="balance"
                placeholder="Balance"
                filterType="number"
                onChange={(name, valueObject) => {
                  if (typeof valueObject === "object" && Object.keys(valueObject).length) {
                    handleChangeFilter(name, {
                      ...valueObject,
                      fieldValue: parseFloat(valueObject.fieldValue)
                    });
                  } else {
                    handleChangeFilter(name, {});
                  }
                }}
                searchOperation={searchOperationGenerator(walletFilters.balance)}
                value={findFilterValue("balance", resultFilers)}
              />
            </div>
            <div className="col-12 col-md-3 mb-3">
              <FilterItem
                name="card.cardMask"
                placeholder="Card Mask"
                filterType="text"
                onChange={handleChangeFilter}
                searchOperation={searchOperationGenerator(walletFilters["card.cardMask"])}
                value={findFilterValue("card.cardMask", resultFilers)}
              />
            </div>
            <div className="col-12 col-md-3 mb-3">
              <FilterItem
                name="currency"
                placeholder="Currency"
                filterType="select_multiple"
                filterTypeOptions={currencies.map(value => ({
                  label: value,
                  value
                }))}
                onChange={handleChangeFilter}
                defaultFilterType={filterTypes.IN.value}
                searchOperation={searchOperationGenerator(walletFilters.currency)}
                value={findFilterValue("currency", resultFilers)}
              />
            </div>
            <div className="col-12 col-md-3 mb-3 offset-md-9">
              <div className="d-flex justify-content-between justify-content-md-end">
                <button
                  className="btn btn-warning btn-sm ml-2"
                  onClick={handleResetLocal}
                >
                  Reset
                </button>
                <button
                  className="btn btn-success btn-sm ml-2"
                  onClick={handleSearchLocal}
                >
                  Load
                </button>
              </div>
            </div>
          </div>
        </Collapse>
      </Card.Body>
    </Card>
  );
};

WalletFilers.defaultProps = {
  activeFilters: {}
};

WalletFilers.propTypes = {
  activeFilters: PropTypes.array.isRequired,
  handleSearch: PropTypes.func.isRequired,
  handleReset: PropTypes.func.isRequired,
  totalCount: PropTypes.number.isRequired,
};

const mapStateToProps = state => ({
  walletFilters: state.wallet.walletFilters,
  currencies: state.transaction.currencies,
});

const mapStateToDispatch = dispatch => ({
  getWalletFilters: bindActionCreators(getWalletFilters, dispatch),
  getCurrencies: bindActionCreators(getCurrencies, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(WalletFilers);



// WEBPACK FOOTER //
// ./src/views/pages/wallet/filters.js